import React from 'react';
import { Investment } from '@/types/investment';

interface PremiseProps {
  investment: Investment;
}

const Premise: React.FC<PremiseProps> = ({ investment }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-foreground">Investment Premise</h2>
      <p className="text-base text-muted-foreground">{investment.premise}</p>
    </div>
  );
};

export default Premise;
